import { motion } from "framer-motion";
import { X } from "lucide-react";
import { InquiryForm } from "./InquiryForm";
import { KiwiMark } from "./KiwiMark";

export const AdmissionsModal = ({ interest, onClose }) => {
  const franchise = interest === "franchise";
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-ink/50 backdrop-blur-sm"
      onClick={onClose}
    >
      <motion.div
        data-testid="admissions-modal"
        initial={{ opacity: 0, y: 48, scale: 0.96 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: 32, scale: 0.97 }}
        transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
        onClick={(e) => e.stopPropagation()}
        className="relative w-full max-w-lg bg-cream rounded-[2rem] p-6 sm:p-8 shadow-2xl max-h-[92vh] overflow-y-auto"
      >
        <button
          data-testid="admissions-modal-close-button"
          onClick={onClose}
          aria-label="Close"
          className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white border border-ink/10 flex items-center justify-center text-ink/60 hover:text-ink hover:rotate-90 transition-all duration-300"
        >
          <X className="w-4 h-4" />
        </button>
        <div className="flex items-center gap-3 mb-2">
          <KiwiMark className="w-9 h-9" />
          <span className="font-play font-semibold text-peach text-sm tracking-wide uppercase">
            {franchise ? "Franchise Partnership" : "Admissions Enquiry"}
          </span>
        </div>
        <h3 className="font-display font-extrabold text-2xl sm:text-3xl text-ink mb-1.5">
          {franchise ? "Let's build a Kiwi Kids together" : "We'd love to meet your little one"}
        </h3>
        <p className="text-sm text-ink/60 mb-6">
          Share your details and we'll call you back — usually within a day.
        </p>
        <InquiryForm
          defaultBranch={franchise ? "Franchise Enquiry" : "Manesar, Gurugram"}
          onSuccess={onClose}
        />
      </motion.div>
    </motion.div>
  );
};
